addEventListener("DOMContentLoaded", function () {
    const article = document.querySelector(".article-content--section .article--inner") || document.querySelector(".article--inner");
    if (!article) return;

    const tocList = document.querySelector("#toc ul");
    const headers = article.querySelectorAll("h2");
    const headerMap = new Map();

    let h2Count = 0;
    let h3Count = 0;
    let lastH2Item = null;

    headers.forEach((header, index) => {
        header.id = `header-${header.tagName}-${index}`;
        const anchorId = `header-${index}`;
        const link = document.createElement("a");
        link.textContent = header.textContent;
        link.href = `#${anchorId}`;
        link.style.cursor = "pointer";

        const listItem = document.createElement("li");
        if (header.tagName === "H2") {
            h2Count++;
            h3Count = 0;
            lastH2Item = listItem;
            link.classList.add('table-h2');
        }

        // if (header.tagName === "H3" && lastH2Item) {
        //     h3Count++;
        //     listItem.style.marginLeft = "20px";

        //     link.textContent = h3Count + '.' + ' ' + header.textContent
        // }

        listItem.appendChild(link);
        listItem.style.listStyle = "none";

        tocList.appendChild(listItem);

        link.addEventListener("click", function (e) {
            e.preventDefault();
            const rect = header.getBoundingClientRect();
            let offset;
            if(window.innerWidth <= 768) {
                offset = window.scrollY + rect.top - 180;
            } else {
                offset = window.scrollY + rect.top - 150;
            }
            window.scrollTo({ top: offset, behavior: "smooth" });
        });

        headerMap.set(anchorId, header);
    });

    let table_show_lm = document.querySelector(".article--table-show");
    table_show_lm.onclick = function() {
        tocList.classList.toggle("active");
        table_show_lm.classList.toggle("active");
    }
});